<div *ngIf="isAuth">
  <div class="assessmnt-widthHeader">
    <!-- header -->
    <div class="Header col-12 nopad">
      <div class="row noMargin justify-content-between headerSpace">
        <!-- Language Dropdown - Mimicking header component functionality -->
        <div *ngIf="languages && languages.length > 1" class="language-dropdown-container mb-2">
          <img  src="../../../assets/icons/globe-earth.png" alt="golbe-earth" width="30" height="30">
          <label for="languageSelect" class="bold-title">{{ 'Language:' | translate }} </label>
          <select id="languageSelect"
                  [(ngModel)]="language"
                  (change)="changeLanguage(language)"
                  [attr.aria-label]="'Select language' | translate"
                  class="form-select">
            <option *ngFor="let language of languages" [value]="language.attribute">
              {{ language.language | translate }}&nbsp;{{language.workForce !== ""? '(' +language.workForce + ')'  : '' | translate}}
            </option>
          </select>
        </div>
      </div>
    </div>
  </div>
  <div class="col-12 mainDiv" *ngIf="!isRequestInvalid">
    <div class="mb-3 mt-5"></div>

    <div class="tableContainer" *ngIf="questionsAndDetails">
      <div class="initials">
        <h3 class="styledUserDetails">
          Person Initials: &nbsp;
        </h3>
        <h3 class="styledUserDetails">
          {{ emailassessmentData.personInitials }}
        </h3>
      </div>
      <div *ngIf="emailassessmentData?.assessment?.externalMessage">
        <span class="bold-title">{{'External Message:' | translate}} &nbsp;</span>
        <span class="sub-title">{{ emailassessmentData?.assessment?.externalMessage }}</span>
      </div>
      <div class="subHeading mb-3">
        <div>
          <h4 class="header-title">
            {{ questionsAndDetails.instrumentAbbrev }}
          </h4>
        </div>
        <div>
          <span class="bold-title">Version: </span>
          <span class="sub-title">{{
            questionsAndDetails.questionnaireName
            }}</span>
          <span class="toggleExpansion">
            <img title="{{ this.expandmessage }}" style="cursor: pointer" (click)="toggleExpansion()"
              src="../../../../assets/icons/view-array-24.png" /></span>
        </div>

        <div *ngIf="questionsAndDetails.instruction !== '' && questionsAndDetails.instruction !== null &&
        questionsAndDetails.instruction !== undefined && questionsAndDetails.instruction !== 'NULL'">
          <span class="bold-title">Instructions: </span>
          <span class="sub-title">{{
            questionsAndDetails.instruction
            }}</span>
        </div>
      </div>
      <form [formGroup]="questionForm">
        <div class="table-responsive scrollHorizontal enableHorScolling">
          <ng-container *ngFor="
              let category of questionCategories.controls;
              let catIndex = index
            " [formGroup]="category">
            <div class="email-assessment-outer"
              *ngIf="isExternalUser ? !(category?.controls?.isAllQuestionsConfidential?.value && isExternalUser): true">
              <div
                *ngIf="!category.controls?.skippedCategory?.value && !category?.controls?.ExcludeFromInviteToComplete?.value && !category.controls?.IsCategoryExpiry?.value"
                class="removeHoverHeader cursorPointer blueHeader">
                <div class="row email-mobile">
                  <div class="spaceCell col-lg-5 col-sm-8" (click)="
                      !category.controls.showSupportDropDown.value &&
                      category.controls.FocusId.value !== 2
                        ? categoryShowHide(
                            category.controls.showCategory,
                            category.controls
                          )
                        : null
                    ">
                    <div class="d-flex justify-content-between col-xs-10 nopad">
                      <div class="titleHeader" (click)="
                      categoryShowHide(
                        category.controls.showCategory,
                        category.controls
                      )
                    " [ngClass]="
                          category.controls.showSupportDropDown.value
                            ? 'add-title-padding'
                            : ''
                        " title="{{ category.controls.CategoryName.value }}">
                        {{ category.controls.CategoryName.value }}
                      </div>
                      <div id="caregivertab" #caregivertab tabindex='1'
                        *ngIf="category.controls.showSupportDropDown.value" class="dropDownContainer">
                        <select formControlName="supportID" (change)="selectSupportName(catIndex)">
                          <option [ngValue]="null" disabled>
                            {{'Select a Support' | translate}}
                          </option>
                          <option [disabled]="support.isDisable" *ngFor="let support of personSupports"
                            [ngValue]="support.personSupportID">
                            {{
                            support.supportFirstName +
                            " " +
                            support.supportLastName
                            }}
                          </option>
                        </select>
                      </div>
                      <div class="titleIcon" (click)="
                          categoryShowHide(
                            category.controls.showCategory,
                            category.controls
                          )
                        ">
                        <i *ngIf="category.controls.CategoryDescription.value"
                          [title]="category.controls.CategoryDescription.value || ''" class="fa fa-info-circle" (click)="
                          categoryShowHide(
                            category.controls.showCategory,
                            category.controls
                          )
                        "></i>
                      </div>
                    </div>
                  </div>
                  <!-- <div class="mobile-collapse"> -->
                  <div class="value align-center col-lg-1 col-sm-2" (click)="
                    categoryShowHide(
                      category.controls.showCategory,
                      category.controls
                    )
                  ">
                    {{ category.controls.summation.value }}
                  </div>
                  <div class="collapseBar col-lg-6 col-sm-2 pt-2" (click)="
                    categoryShowHide(
                      category.controls.showCategory,
                      category.controls
                    )
                  ">
                    <div class="d-flex">
                      <div class="styledProgressBar">
                        <div class="mr-3 mt-1">
                          <section class="progress-bar-section" *ngIf="category.controls.percentage.value >= 0">
                            <mat-progress-bar [ngClass]="
                              category.controls.progressBarColor.value
                            " [value]="category.controls.percentage.value">
                            </mat-progress-bar>
                            <div style="
                              position: absolute;
                              padding: 10px;
                              color: #000;
                            ">
                              {{ category.controls.percentage.value }} %
                            </div>
                          </section>
                        </div>
                      </div>
                      <span>
                        <i *ngIf="!category.controls.showCategory.value" style="padding: 0"
                          class="fa fa-caret-right removePad" aria-hidden="true"></i>
                        <i *ngIf="category.controls.showCategory.value" style="padding: 0"
                          class="fa fa-caret-down removePad" aria-hidden="true"></i>
                      </span>
                    </div>
                  </div>
                  <!-- </div> -->

                </div>
              </div>

              <div class="TableBody"
                *ngIf="category.controls.showCategory.value && !category.controls.skippedCategory.value && !category?.controls?.ExcludeFromInviteToComplete?.value  && !category.controls.IsCategoryExpiry.value">
                <ng-container *ngFor="
                    let versionItem of category.get('versionItems').controls;
                    let verIndex = index
                  " [formGroup]="versionItem">
                  <div class="rowClass row col-lg-6 col-sm-10 styledBorderBottom nopad"
                    *ngIf="isExternalUser ? !versionItem.controls.isShowItemRow.value && !versionItem.value?.assesments?.[0]?.isSkipped && !(getConfidential(versionItem.controls) && isExternalUser) : !versionItem.controls.isShowItemRow.value && !versionItem.value?.assesments?.[0]?.isSkipped">
                    <div class="spaceCell col-lg-10 col-sm-10 styledBorderRight " [ngClass]="{
                        'overlay-conf': getConfidential(versionItem.controls),'tablerowDisable':versionItem.controls.showDropDown.value == true
                      }">
                      <div class="title pt-3">
                        <span class="d-flex to-right ml-0">
                          <span class="d-flex">
                            <a class="plusCircleIcon">
                              <img *ngIf="!versionItem.controls.isShowCard.value" (click)="
                                  showCard(versionItem.controls.isShowCard)
                                " src="../../../assets/icons/Plus.png" alt="plusIcon" />
                              <img *ngIf="versionItem.controls.isShowCard.value" (click)="
                                  showCard(versionItem.controls.isShowCard)
                                " src="../../../assets/icons/Minus_for_Popup.png" alt="plusIcon" />
                            </a>
                            <span>
                              <span class="unbreakable-text" [ngClass]="
                                  (currentQuestionIndex === verIndex) &&
                                  currentCategoryIndex === catIndex && enableHighlight
                                    ? ('labelTitle selectionBackground')
                                    : ('labelTitle') && (versionItem.controls.isResponseRequired.value)  && (versionItem.controls.ResponseId.disabled)
                                "
                                title="{{versionItem.controls.Title.value}}"> <!--(Question End Date : {{versionItem.controls.endDate.value}}) -->
                                {{versionItem.controls.Title.value }}</span>
                              </span>
                              <span *ngIf="versionItem.controls.isResponseRequired.value && isEnabledasterisk"
                              [style.color]=" versionItem.controls.ResponseId.disabled ? 'grey' : 'red'"> *</span>
                            <span class="ml-2" title="Notes Available" *ngIf="getNotesLength(versionItem.controls) != 0">
                              <span>
                                <i class="fa fa-sticky-note styledIcon"></i>
                                <span class="badge">
                                  {{ getNotesLength(versionItem.controls) }}
                                </span>
                              </span>
                            </span>
                            <span style="padding-left: 30px;"
                              *ngIf="versionItem.controls.IsReceiver.value == true && versionItem.controls?.IsChildItemReceiver?.value == false">
                              <button type="button" class="btn btnBlueLight form-group ml-0 width-auto"
                                [style.background-color]="brandingDetails?.branding?.BackgroundColors?.BtnBlue"
                                (click)="generateSmartListResponses(catIndex,verIndex,versionItem.value, 1)" mat-button>
                                {{'Generate' | translate}}
                              </button>
                            </span>
                          </span>
                          <span>
                            <span class="ml-2 d-flex justify-content-center align-items-center"
                              style="color:darkslategrey;" *ngIf="getConfidential(versionItem.controls)">
                              <img class="confidentialityIcon" matTooltip="Confidentiality" matTooltipPosition="right"
                                style="margin:0;margin-top:-1px;width:24px;height:24px;"
                                src="../../../assets/icons/confidential/confidential2-brown-red.png">
                            </span>
                          </span>
                        </span>

                      </div>
                    </div>
                    <div *ngFor="
                        let assesment of versionItem.get('assesments').controls;
                        let aIndex = index
                      " [formGroup]="assesment" class="value align-center col-lg-2 col-sm-2" [ngClass]="{
                        focusCurrentDropdown:
                          currentQuestionIndex === verIndex &&
                          currentCategoryIndex === catIndex,
                        'overlay-conf':
                        (assesment.controls.isRequiredConfidential.value || assesment.controls.isPersonRequestedConfidential.value || assesment.controls.isOtherConfidential.value)
                      }" style="padding: 0px !important">
                      <div
                        [ngClass]="!assesment.controls?.ResponseId.valid && assesment.controls?.ResponseId.hasError('incorrect')? 'required':''"
                        class="style-dropdown-assessment" style="height: inherit;"
                        [matTooltip]="getErrorMessage(versionItem.controls.ItemId.value)">
                        <div [ngClass]="{'disabled-bckground': assesment.controls?.isSkipped.value}"
                          style="height: inherit"
                          [style.background]="colorPaletteWithIsConfidential(assesment, (assesment.controls.isRequiredConfidential.value || assesment.controls.isPersonRequestedConfidential.value || assesment.controls.isOtherConfidential.value))">
                          <div [ngClass]="{
                            'unHighlightDiv': !enableHighlight,
                            'highlightDiv': enableHighlight,
                            'maximum-height': versionItem.controls.Title.value.length > 50,
                            'medium-height': versionItem.controls.Title.value.length > 20 && versionItem.controls.Title.value.length <= 50,
                            'normal-height': versionItem.controls.Title.value.length <= 20
                          }">
                            <ng-container
                              *ngIf="assesment.controls.showDropDown.value && versionItem.controls.responseValueTypeID.value === responseTextAreaType">
                              <mat-form-field class="example-full-width email-assessment-text-field ">
                                <textarea rows="1" formControlName="value" (keyup)="textValueChange(catIndex,verIndex, 1)" [id]="isEmailFormatItem(versionItem) ? ('email-input-' + catIndex + '-' + verIndex + '-' + aIndex) : ('mat-select-' + catIndex + '-' + verIndex)"
                                  (click)="textAreaClicked(catIndex,verIndex); selectQuestion(catIndex, verIndex)"
                                  (change)="changeText($event,catIndex,verIndex)"
                                  (paste)="onTextPaste(catIndex,verIndex,$event, 1)"
                                  (keydown)="tabPressed($event, versionItem.controls, category.controls,catIndex, verIndex)"
                                  [mask]="shouldApplyMask && !isEmailFormatItem(versionItem) ? versionItem.controls.ItemFormat.value: null"
                                  matInput></textarea>
                                <!-- PCIS-10708: email format validation error -->
                                <mat-error *ngIf="isEmailFormatItem(versionItem) && assesment.controls.value?.hasError('pattern')">
                                  {{ alertMessage.emailValid | translate }}
                                </mat-error>
                              </mat-form-field>
                            </ng-container>
                            <ng-container
                              *ngIf="assesment.controls.showDropDown.value && versionItem.controls.responseValueTypeID.value === responseListType && !versionItem.controls.IsResponseIdAvailable.value">
                              <mat-select #assessmentOptions [id]="'mat-select-' + catIndex + '-' + verIndex"
                                (click)="selectQuestion(catIndex, verIndex);"
                                (keydown)="onResponseChange('',catIndex,verIndex, $event);onKeyPressed($event, versionItem.controls, category.controls, assessmentOptions, catIndex, verIndex)"
                                (selectionChange)="onResponseChange('',catIndex,verIndex, $event);onQsSelectChange($event, versionItem.controls);"
                                disableOptionCentering panelClass="assesmentValuesDropdown" formControlName="value"
                                class="assessmentDropDown"
                                matTooltip="{{getLabelFromValue(assesment.controls.value.value,versionItem.get('Responses').controls) === '-' ? '' : getLabelFromValue(assesment.controls.value.value,versionItem.get('Responses').controls)}}"
                                matTooltipPosition="right">
                                <mat-option [value]="'-'" class="assessmentDropDown"> - </mat-option>
                                <mat-option *ngFor="let responses of versionItem.get('Responses').controls"
                                  [formGroup]="responses" [value]="responses.controls.Value.value"
                                  class="assessmentDropDown">
                                  {{ getTruncatedLabel(responses.controls.Label.value)}}
                                </mat-option>
                              </mat-select>
                            </ng-container>
                            <ng-container
                              *ngIf="assesment.controls.showDropDown.value && versionItem.controls.responseValueTypeID.value === responseCustomListType">
                              <mat-select #currentAddressDropdown formControlName="value" (selectionChange)="onResponseAddressChange(catIndex,verIndex, $event); " (click)="selectQuestion(catIndex, verIndex);" [id]="'mat-select-' + catIndex + '-' + verIndex" (keydown)="onKeyPressed($event, versionItem.controls, category.controls, currentAddressDropdown, catIndex, verIndex)">
                              <mat-option [value]="'-'"> - </mat-option>
                              <mat-option *ngFor="let address of fullAddressList; let m = index" [value]="address.addressName" matTooltip="{{address.addressName}}"
                              matTooltipPosition="right">
                                {{address.addressName }}
                              </mat-option>
                            </mat-select>
                            </ng-container>

                            <ng-container
                              *ngIf="assesment.controls.showDropDown.value && (versionItem.controls.responseValueTypeID.value === scoreResponseListType)">
                              <mat-select #currentDropdown [id]="'mat-select-' + catIndex + '-' + verIndex"
                                [attr.disabled]="true" formControlName="ResponseId" disableOptionCentering
                                panelClass="assesmentValuesDropdown"
                                matTooltip="{{getLabelFromValue(assesment.controls.ResponseId.value,versionItem.get('Responses').controls) === '-' ? '' : getLabelFromValue(assesment.controls.ResponseId.value,versionItem.get('Responses').controls)}}"
                                matTooltipPosition="right">
                                <mat-option
                                  *ngFor="let response of versionItem.get('Responses').controls; let m = index"
                                  [formGroup]="response" [value]="response.controls.ResponseId.value"
                                  class="peoplesDomainTableDropDown"
                                  matTooltip="{{getLabelFromValue(assesment.controls.value.value,versionItem.get('Responses').controls) === '-' ? '' : getLabelFromValue(assesment.controls.ResponseId.value,versionItem.get('Responses').controls)}}"
                                  matTooltipPosition="right">
                                  {{ getTruncatedLabel(response.controls.Label.value)}}</mat-option>
                              </mat-select>
                            </ng-container>

                            <ng-container
                              *ngIf="assesment.controls.showDropDown.value && versionItem.controls.responseValueTypeID.value === responseListType && versionItem.controls.IsResponseIdAvailable.value">
                              <mat-select #assessmentOptions [id]="'mat-select-' + catIndex + '-' + verIndex"
                                (click)="selectQuestion(catIndex, verIndex);"
                                (keydown)="showWarningSavePromptBeforeChange(catIndex,verIndex, $event,versionItem,'collapsed_keyEvent',assessmentOptions,null, category)"
                                (selectionChange)="showWarningSavePromptBeforeChange(catIndex,verIndex, $event,versionItem,'collapsed_itemClick',assessmentOptions,null,category)"
                                disableOptionCentering panelClass="assesmentValuesDropdown" formControlName="ResponseId"
                                class="assessmentDropDown"
                                matTooltip="{{getLabelFromValue(assesment.controls.value.value,versionItem.get('Responses').controls) === '-'? '' : getLabelFromValue(assesment.controls.value.value,versionItem.get('Responses').controls)}}"
                                matTooltipPosition="right">
                                <mat-option [value]="'-'" class="assessmentDropDown"> - </mat-option>
                                <mat-option *ngFor="let responses of versionItem.get('Responses').controls"
                                  [formGroup]="responses" [value]="responses.controls.ResponseId.value"
                                  class="assessmentDropDown">
                                  {{ getTruncatedLabel(responses.controls.Label.value)}}
                                </mat-option>
                              </mat-select>
                            </ng-container>

                            <ng-container *ngIf="!assesment.controls.showDropDown.value">
                              -
                            </ng-container>
                            <ng-container
                              *ngIf="assesment.controls.showDropDown.value && versionItem.controls.responseValueTypeID.value === responseSliderType">
                              <div>
                                <input (change)="onSliderChange($event?.target?.value,catIndex,verIndex);" [id]="'mat-select-'+catIndex+'-'+verIndex"
                                  (keyup)="onSliderChange($event?.target?.value,catIndex,verIndex);" min="0"
                                  (keydown)="tabPressed($event, versionItem.controls, category.controls,catIndex, verIndex)" (click)="selectQuestion(catIndex, verIndex);"
                                  [max]="versionItem?.controls?.Responses?.value[1]?.MaxRangeValue" matInput
                                  formControlName="value" type="number" style="width: 80px;" appNoDecimal>
                              </div>
                            </ng-container>

                            <ng-container
                              *ngIf="assesment.controls.showDropDown.value && versionItem.controls.responseValueTypeID.value === scoreResponseType">
                              <div style="padding: 14px;">
                                <input readonly matInput formControlName="value" type="number" [id]="'mat-select-'+catIndex+'-'+verIndex" (keydown)="tabPressed($event, versionItem.controls, category.controls,catIndex, verIndex)">
                              </div>
                            </ng-container>

                            <ng-container
                              *ngIf="assesment.controls.showDropDown.value && versionItem.controls.responseValueTypeID.value === responseDateType"
                              class="textingPermitted">
                              <mat-form-field *ngIf="!versionItem.controls.isNotApplicable.value" color="accent"
                                appearance="fill">
                                <input [disabled]="" [disabled]="versionItem.controls.isNotApplicable.value" [id]="'mat-select-' + catIndex + '-' + verIndex"
                                  formControlName="value"
                                  (dateChange)="onResponseChange('responseDate',catIndex, verIndex, $event)" matInput
                                  (keypress)="validateDateFormat($event, responseDateDropDown); tabPressed($event, versionItem.controls, category.controls,catIndex, verIndex)"
                                  (keyup)="validateFullDate(responseDateDropDown)" (click)="selectQuestion(catIndex, verIndex);"
                                  (blur)="isValidDate($event, responseDateDropDown, responseDateDropDown)"
                                  [matDatepicker]="pickerForResponseDropDown" #responseDateDropDown>
                                <mat-datepicker-toggle matSuffix [for]="pickerForResponseDropDown">
                                </mat-datepicker-toggle>
                                <mat-datepicker #pickerForResponseDropDown>
                                </mat-datepicker>
                                <mat-error *ngIf="responseDateDropDown.isDateValid" class="dateFieldError">
                                  {{"Please enter valid date." | translate}}
                                </mat-error>
                              </mat-form-field>
                            </ng-container>
                            <ng-container
                              *ngIf="assesment.controls.showDropDown.value && (versionItem.controls.responseValueTypeID.value === responseSignatureType || versionItem.controls.responseValueTypeID.value === responseDoodleType)"
                              class="textingPermitted">
                              <div style="padding: 14px;" >
                              </div>
                            </ng-container>
                            <div
                              *ngIf="(versionItem.controls.isNotApplicable.value && assesment.controls.value.value) && assesment.controls.showDropDown.value"
                              style="padding: 14px 40px 0 0;text-overflow: ellipsis;overflow-x: clip;"
                              matTooltip="{{getLabelFromValue(assesment.controls.value.value,versionItem.get('Responses').controls) ==='-' ? '' : getLabelFromValue(assesment.controls.ResponseId.value,versionItem.get('Responses').controls)}}"
                              matTooltipPosition="right">
                              {{getTruncatedLabelFromValue(assesment, versionItem.get('Responses').controls,
                              versionItem)}}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="removeHover"
                    *ngIf="versionItem.controls.isShowCard.value && (versionItem.controls.responseValueTypeID.value === responseSignatureType || versionItem.controls.responseValueTypeID.value === responseDoodleType) && !versionItem.value?.assesments?.[0]?.isSkipped"
                    [id]="'signature-' + catIndex + '-' + verIndex ">
                    <div style="white-space: unset" colspan="9" class="styledWhiteBackground">
                      <div class="card toggleCard">
                        <div class="card-body">
                          <div class="details-row">
                            <p class="versiontitle versionlabel">{{versionItem.controls.Title.value}}</p>
                            <div class="versiontitle contentText" [innerHtml]="versionItem.controls.Description.value">
                            </div>
                          </div>
                          <div [ngClass]="versionItem.value.assesments[0].isSkipped ? 'disabled ': ''"
                            class="details-row">
                            <app-signature-pad [versionItem]="versionItem" [category]="catIndex" [index]="verIndex"
                              [type]="versionItem.controls.responseValueTypeID.value"
                              [signatureType]="responseSignatureType" [doodleType]="responseDoodleType"
                              (CustomCallBack)="CustomCallBack($event)"
                              (CustomCallBackOnEdit)="CustomCallBackOnEdit($event)" [imageArray]="signatureArray"
                              [qStatus]="null" [assesmentNumber]="emailassessmentData?.assessment?.assessmentID"
                              [formViewFlag]="false">
                            </app-signature-pad>
                          </div>
                          <div
                            *ngIf="versionItem.controls.supplementalDescription.value != null && versionItem.controls.supplementalDescription.value != ''"
                            class="details-row">
                            <h2 class="subtitle">{{'Supplemental Description' | translate}}:</h2>
                            <p class="versiontitle contentText"
                              [innerHtml]="versionItem.controls.supplementalDescription.value"></p>
                          </div>
                          <!-- add note -->
                           <ng-container
                            *ngIf="showHideNotes(versionItem.controls.NotesRequired.value, versionItem.controls.ShowNotes.value)">
                          <div class="details-row mt-3" *ngIf="versionItem.controls.resValue.value != null">
                            <h2 *ngIf="getNotesLength(versionItem.controls) != 0" class="subtitle">{{'Notes or Comments' | translate}}:
                            </h2>
                            <div *ngFor="let note of getNotes(versionItem.controls).controls;let noteIndex = index"
                              [formGroup]="note">
                              <hr />
                              <ng-container *ngIf="!note.controls.isEdit.value">
                                {{ note.controls.noteText.value }}
                              </ng-container>

                              <ng-container *ngIf="note.controls.isEdit.value">
                                <div class="col-12 d-flex">
                                  <div class="col-10">
                                    <mat-form-field [formGroup]="versionItem" hideRequiredMarker class="custom-hide-underline">
                                      <mat-label>{{'Notes or Comments' | translate}}<span style="color: red">*</span>
                                      </mat-label>
                                      <textarea matInput formControlName="noteText" class="noteTextAreaDrag"
                                        [attr.maxLength]="constants?.descriptionLength" #noteEditInput></textarea>
                                    </mat-form-field>
                                  </div>
                                  <div class="col-1 style-center">
                                    <a href="javascript:void(0)" class="checkItem"
                                      (click)="setNotes(versionItem.controls,'edit',noteIndex)">
                                      <i class="fa fa-check-circle"></i>
                                    </a>
                                  </div>
                                  <div class="col-1 style-center">
                                    <a href="javascript:void(0)" class="deleteItem"
                                      (click)="clearNotes(versionItem.controls,noteIndex)">
                                      <i class="fa fa-times-circle"></i>
                                    </a>
                                  </div>
                                </div>
                              </ng-container>
                              <div class="d-flex justify-content-end styledMargin" *ngIf="!isRequestSubmitted">
                                <div>
                                  <div class="mb-2">
                                    <a href="javascript:void(0)" class="AddItem assesmentAddBtn"
                                      (click)="editNote(versionItem.controls,noteIndex)">
                                      <i aria-hidden="true" class="fa fa-plus mr-1"></i>{{'Edit Note' | translate}}
                                    </a>
                                  </div>
                                  <div class="mb-2">
                                    <a href="javascript:void(0)" class="AddItem assesmentAddBtn"
                                    (click)="deleteItemPopUp(versionItem.controls,noteIndex)">
                                      <i aria-hidden="true" class="fa fa-minus mr-1"></i>{{'Delete Note' | translate}}
                                    </a>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div *ngIf="versionItem.controls.showAddNote.value">
                              <hr />
                              <div class="col-12 styledNoteContainer">
                                <div class="col-lg-7">
                                  <mat-form-field [formGroup]="versionItem" hideRequiredMarker class="custom-hide-underline">
                                    <mat-label>{{'Notes or Comments' | translate}} <span style="color: red">*</span></mat-label>
                                    <textarea matInput formControlName="noteText" class="noteTextAreaDrag"
                                      [attr.maxLength]="constants?.descriptionLength" #noteInput></textarea>
                                  </mat-form-field>
                                </div>
                                <div class="ml-5 mb-5 style-center d-flex buttonContainer">
                                  <a href="javascript:void(0)" class="checkItem"
                                    (click)="setNotes(versionItem.controls)">
                                    <i class="fa fa-check-circle"></i>
                                  </a>
                                  <a href="javascript:void(0)" class="deleteItem"
                                    (click)="clearNotes(versionItem.controls)">
                                    <i class="fa fa-times-circle"></i>
                                  </a>
                                </div>
                              </div>
                              <hr />
                            </div>
                            <div *ngIf="!versionItem.controls.showAddNote.value">
                              <hr />
                            </div>
                            <div class="d-flex justify-content-end"
                              *ngIf=" versionItem.controls.showAddNoteLink.value && !isRequestSubmitted">
                              <a href="javascript:void(0)" class="AddItem assesmentAddBtn"
                                (click)="addNote(versionItem.controls)">
                                <i aria-hidden="true" class="fa fa-plus mr-1"></i>{{'Add Note' | translate}}
                              </a>
                            </div>
                          </div>
                          </ng-container>
                          <!-- add note end -->
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="removeHover"
                    *ngIf="versionItem.controls.isShowCard.value && (versionItem.controls.responseValueTypeID.value != responseSignatureType && versionItem.controls.responseValueTypeID.value != responseDoodleType) && !versionItem.value?.assesments?.[0]?.isSkipped">
                    <div style="white-space: unset" colspan="9" class="styledWhiteBackground" >
                      <div class="card toggleCard"
                      [style.background-color]="brandingDetails?.branding?.BackgroundColors?.QuestionnaireCardBackground">
                        <div class="card-body">
                          <div class="details-row">
                            <p class="versiontitle contentText" [innerHtml]="versionItem.controls.Description.value">
                            </p>
                          </div>
                          <div class="details-row mt-2">
                          </div>
                          <div class="option radioStylesOverride">
                            <div
                              *ngIf="versionItem.controls.responseValueTypeID.value === responseListType && !versionItem.controls.IsResponseIdAvailable.value"
                              class="d-flex mb-2">
                              <!-- Response radio button -->
                              <mat-radio-group formControlName="resValue">
                                <div *ngFor="let response of versionItem.get('Responses').controls" class="d-flex">
                                  <mat-radio-button (change)="onResponseChange('',catIndex,verIndex, $event);"
                                    [formGroup]="response" [value]="response.controls.Value.value"
                                    (click)="showWarningSavePromptBeforeChange(catIndex,verIndex, $event,versionItem,'undo_itemClick',null,response?.controls?.ResponseId?.value,null)">
                                  </mat-radio-button>
                                  <div class="radioBtnDetails">
                                    <b style="text-align: justify">
                                      ({{response.controls.KeyCodes.value}})
                                    </b>&nbsp;
                                    {{ response.controls.Description.value |translate}}
                                  </div>
                                </div>
                              </mat-radio-group>
                              <div></div>
                            </div>

                            <div
                              *ngIf="versionItem.controls.responseValueTypeID.value === responseListType && versionItem.controls.IsResponseIdAvailable.value"
                              class="d-flex mb-2">
                              <!-- Response radio button -->
                              <mat-radio-group formControlName="ResponseId">
                                <div *ngFor="let response of versionItem.get('Responses').controls" class="d-flex">
                                  <mat-radio-button
                                    (change)="showWarningSavePromptBeforeChange(catIndex,verIndex, $event,versionItem,'expanded_itemClick',null,response?.controls?.ResponseId?.value,null)"
                                    [formGroup]="response" [value]="response.controls.ResponseId.value"
                                    (click)="showWarningSavePromptBeforeChange(catIndex,verIndex, $event,versionItem,'undo_itemClick',null,response?.controls?.ResponseId?.value,null)">
                                  </mat-radio-button>
                                  <div class="radioBtnDetails">
                                    <b style="text-align: justify">
                                      ({{response.controls.KeyCodes.value}})
                                    </b>&nbsp;
                                    {{ response.controls.Description.value | translate}}
                                  </div>
                                </div>
                              </mat-radio-group>
                              <div></div>
                            </div>
                            <!-----Address-->
                            <div
                              *ngIf="versionItem.controls.responseValueTypeID.value === responseCustomListType"
                              class="d-flex mb-2">
                              <mat-form-field
                                      appearance="fill" [ngClass]="validateResponse(catIndex,verIndex)? 'address-requred':''">
                                      <mat-select #currentAddressDropdown appearance="fill"
                                      formControlName="resValue" (selectionChange)="onResponseAddressChange(catIndex,verIndex, $event);"
                                      disableOptionCentering panelClass="assesmentValuesDropdown">
                                      <mat-option [value]="'-'"> - </mat-option>
                                      <mat-option *ngFor="let address of fullAddressList; let m = index" [value]="address.addressName" matTooltip="{{address.addressName}}"
                                      matTooltipPosition="right" >
                                        {{address.addressName }}
                                      </mat-option>
                                    </mat-select>
                                    </mat-form-field>
                              </div>

                            <div *ngIf="versionItem.controls.responseValueTypeID.value === scoreResponseListType"
                              class="col-12" style="padding-left:0px">
                              <mat-radio-group formControlName="ResponseId">
                                <div *ngFor="let response of versionItem.get('Responses').controls; let m = index"
                                  class="d-flex">
                                  <mat-radio-button [formGroup]="response" [value]="response.controls.ResponseId.value" disabled>
                                  </mat-radio-button>
                                  <div style="text-align: justify; padding: 0 0 10px 10px; font-weight: 400;">
                                    <span>
                                      <b>{{getTruncatedLabel(response.controls.Label.value)}}</b>
                                      <b style="text-align: justify;">&nbsp;({{response.controls.KeyCodes.value}})</b>
                                      =
                                    </span>
                                    {{response.controls.Description.value | translate}}
                                    <b style="text-align: justify;">&nbsp;({{response.controls.Value.value}})</b>
                                  </div>
                                </div>
                              </mat-radio-group>
                              <div>
                              </div>
                            </div>
                            <div *ngIf="versionItem.controls.responseValueTypeID.value === responseAttachmentType">
                              <div>

                                <ng-container>
                                  <div class="file-input">
                                    <input
                                      type="file" [accept]="assessmentConfig.assesmentFileTypes" id="file"
                                      class="file" (change)="handleFileInput($event.target.files, catIndex, verIndex, false)">
                                    <label for="file">
                                      Browse
                                    </label>
                                  </div>
                                </ng-container>
                              </div>
                              <div class="top-margin " >
                                <div
                                  *ngFor="let files of getFiles(versionItem?.controls?.ItemId?.value, catIndex, verIndex,false)?.controls; let f = index"
                                  [formGroup]="files" class="d-flex" class="d-flex">
                                  <p (click)="downloadFile(files.value)" style="cursor: pointer"
                                    class="attachment-list">{{files.controls.fileName.value}}</p>
                                  <h5 class="stylednoteFont-attachment attachment-list">{{'Created on'|translate}}
                                    {{ files.controls.UpdateDate.value ? (files.controls.UpdateDate.value |
                                    date:'MM/dd/yyyy') : (currentDate | date:'MM/dd/yyyy') }} {{'by'|translate}}
                                    {{files.controls.Author.value}}</h5>
                                  <i
                                    (click)="removeFile(catIndex, verIndex ,f)" style="cursor: pointer;"
                                    class="fa fa-trash delete-icon" aria-hidden="true"></i>
                                </div>
                              </div>
                            </div>
                            <div *ngIf="versionItem.controls.responseValueTypeID.value === scoreResponseType"
                              class="d-flex mb-2">
                              <span class="ml-2" style="display: inline-flex;align-items: center;">
                                SCORE = {{checkScore(versionItem.controls.resValue.value)}}
                              </span>
                            </div>

                            <div *ngIf="versionItem.controls.responseValueTypeID.value === responseDateType"
                            [ngClass]="validateResponse(catIndex,verIndex)? 'required':''"
                              class="d-flex styledNoteDate mb-2">
                              <div *ngFor="let response of versionItem.get('Responses').controls; let m = index"
                                class="d-flex">
                                <div style="text-align: justify; padding: 0; padding-top:20px;font-weight: 400;"
                                  *ngIf="response.controls.Label.value === 'N/A'" class="textingPermitted">
                                  <div class="checkBoxText">{{response.controls.Description.value | translate}}</div>
                                  <div>
                                    <mat-checkbox (change)="onCheckBoxChange($event.checked,catIndex, verIndex);"
                                      formControlName="isNotApplicable" class="mr-3"></mat-checkbox>
                                  </div>
                                </div>
                                <div
                                  *ngIf="response.controls.Label.value !== 'N/A' && response.controls.Label.value !== '-'"
                                  class="textingPermitted col-12">
                                  <mat-form-field color="accent" appearance="fill" class="styledDatePicker">
                                    <input [disabled]="versionItem.controls.isNotApplicable.value"
                                      (keypress)="validateDateFormat($event, responseDate)"
                                      (keyup)="validateFullDate(responseDate)"
                                      (blur)="isValidDate($event, responseDate, responseDate)"
                                      formControlName="resValue"
                                      (dateChange)="onResponseChange('responseDate',catIndex, verIndex, $event)"
                                      matInput [matDatepicker]="pickerForResponse" #responseDate>
                                    <mat-datepicker-toggle matSuffix [for]="pickerForResponse">
                                    </mat-datepicker-toggle>
                                    <mat-datepicker #pickerForResponse>
                                    </mat-datepicker>
                                    <mat-error *ngIf="responseDate.isDateValid" class="dateFieldError">
                                      {{"Please enter valid date." | translate}}
                                    </mat-error>
                                  </mat-form-field>
                                </div>
                              </div>
                            </div>

                            <div class="option radioStylesOverride"
                              *ngIf="versionItem.controls.responseValueTypeID.value == responseDocuSignType">
                              <div class="d-flex mb-2">
                                <div class="btmBtnLogoContainer align-start">
                                  <div>

                                    <div
                                      *ngIf="versionItem.controls.resValue.value == '-' || versionItem.controls.resValue.value == null;else buttonTemplate">
                                      <button type="button" class="btn btnBlueLight form-group width-auto"
                                        (click)="generateLink(catIndex, verIndex, versionItem.controls.ItemId.value)"
                                        mat-button>
                                        {{'Click here to DocuSign' | translate}}
                                      </button>
                                    </div>
                                    <ng-template #buttonTemplate>
                                      <button type="button"
                                        (click)="viewDocument(versionItem.controls.resValue.value,catIndex, verIndex)"
                                        class="btn btnBlueLight form-group width-auto" mat-button>
                                        {{'View Document' | translate}}
                                      </button>
                                    </ng-template>
                                  </div>
                                </div>
                              </div>
                            </div>

                            <div *ngIf="versionItem.controls.responseValueTypeID.value === responseSliderType"
                              class="d-flex mb-2">
                              <mat-slider
                               [displayWith]="formatLabel"
                               [min]="0"
                               [max]="versionItem?.controls?.Responses?.value[0]?.MaxRangeValue"
                               step="1"
                               discrete>

                               <input
                                   matSliderThumb
                                   formControlName="resValue"
                                   (valueChange)="
                                       setQsResponse($event, versionItem.controls, catIndex, verIndex);
                                       onSliderChange($event, catIndex, verIndex);
                                   ">
                              </mat-slider>
                              <span style="display: inline-flex;align-items: center;" *ngIf="!isNaN(versionItem.controls.resValue.value)">
                                {{versionItem.controls.resValue.value}}
                              </span>
                            </div>
                            <div *ngIf="versionItem.controls.responseValueTypeID.value === responseTextAreaType"
                              class="d-flex mb-2">
                              <mat-form-field class="custom-hide-underline example-full-width resizable-textarea-field">
                                <textarea formControlName="resValue" (keyup)="textValueChange(catIndex,verIndex, 2)"
                                  [id]="isEmailFormatItem(versionItem) ? ('email-input-' + catIndex + '-' + verIndex) : null"
                                  (click)="textAreaClicked(catIndex,verIndex)"
                                  (change)="changeText($event,catIndex,verIndex)"
                                  (paste)="onTextPaste(catIndex,verIndex,$event, 2)"
                                  matInput
                                  [mask]="shouldApplyMask && !isEmailFormatItem(versionItem) ? versionItem.controls.ItemFormat.value: null" [ngClass]="validateResponse(catIndex,verIndex)? 'textAreaDrag required':'textAreaDrag'"></textarea>
                                <!-- PCIS-10708: email format validation error -->
                                <mat-error *ngIf="isEmailFormatItem(versionItem) && versionItem.controls.resValue?.hasError('pattern')">
                                  {{ alertMessage.emailValid | translate }}
                                </mat-error>
                              </mat-form-field>
                            </div>
                          </div>

                          <!--Sub Section-->
                          <div *ngIf="versionItem.controls.displayChildItem.value"
                            class="styledDisplayChildItem col-lg-6 col-md-10">
                            <div
                              *ngIf="versionItem.controls.IsReceiver.value == true && versionItem.controls?.IsChildItemReceiver?.value == true">
                              <button type="button" class="btn btnBlueLight form-group ml-0 width-auto"
                                [style.background-color]="brandingDetails?.branding?.BackgroundColors?.BtnBlue"
                                (click)="generateSmartListResponses(catIndex,verIndex,versionItem.value, 2)" mat-button>
                                {{'Generate' | translate}}
                              </button>
                            </div>
                            <div *ngFor="let child of versionItem.get('childItems').controls;let c = index;"
                              [formGroup]="child" class="styledHeight">
                              <div *ngIf="showGroupTitle(c,child.controls.total.value)">
                                <div class="childGroups col-12" *ngIf="child.controls.isHidden.value !== true">
                                  <a
                                    (click)="child.controls.isChildCollapsed.value ? expandChild(c,child.controls.total.value,catIndex, verIndex) : collapseChild(c,child.controls.total.value,catIndex, verIndex)">
                                    <i aria-hidden="true" *ngIf="!child.controls.isChildCollapsed.value"
                                      class="fa fa-minus mr-1 mt-2 "></i>
                                    <i aria-hidden="true" *ngIf="child.controls.isChildCollapsed.value"
                                      class="fa fa-plus mr-1 "></i>
                                    {{versionItem.controls.Title.value}} {{ versionItem.controls.displayMultiple.value ? 'Group ' + child.controls.groupNo.value : '' }}
                                  </a>
                                </div>
                              </div>
                              <div [ngbCollapse]="child.controls.isChildCollapsed.value">
                                <div
                                  *ngIf="child.controls.ResponseValueTypeID.value === responseTextType && child.controls.isHidden.value !== true"
                                  class="d-flex justify-content-evenly centerDiv">
                                  <div class="col-4">
                                    <label>{{child.controls.ChildItemTitle.value}}<span *ngIf="child.value.IsChildItemResponseRequired && isEnabledasterisk"  style="color: red;"> *</span></label>
                                  </div>
                                  <div class="col-8">
                                    <ng-container>
                                      <mat-form-field
                                        [ngClass]="!child.controls?.childValue.valid && child.controls?.childValue.hasError('incorrect')? 'required':''"
                                        appearance="fill">
                                        <input type="text" formControlName="childValue" matInput class="pl-0" (change)="findAssesmentSummation();">
                                      </mat-form-field>
                                    </ng-container>
                                  </div>
                                </div>


                                <div
                                  *ngIf="(child.controls.ResponseValueTypeID.value === responseSignatureType || child.controls.ResponseValueTypeID.value === responseDoodleType)  && child.controls.isHidden.value !== true"
                                  class="col-12" style="padding-left:0px">
                                  <div class="col-8">
                                    <label>{{child.controls.ChildItemTitle.value}}<span *ngIf="child.value.IsChildItemResponseRequired && isEnabledasterisk"  style="color: red;"> *</span></label>
                                  </div>
                                  <div class="btmBtnLogoContainer align-start">
                                    <app-signature-pad
                                       [versionItem]="versionItem" [category]="catIndex"
                                       [group]="child.value.groupNo" [groupItem]="child.value.ListOrder" [child]="c" [childData]="child.value"
                                       [index]="verIndex" [type]="child.controls.ResponseValueTypeID.value"
                                      [signatureType]="responseSignatureType" [doodleType]="responseDoodleType"
                                      (CustomCallBack)="CustomCallBack($event)"
                                      (CustomCallBackOnEdit)="CustomCallBackOnEdit($event)"
                                      [imageArray]="signatureArray" [qStatus]="null"
                                      [assesmentNumber]="emailassessmentData?.assessment?.assessmentID"
                                      [formViewFlag]="false"
                                      [isChildItem]="true"
                                      >
                                    </app-signature-pad>
                                  </div>
                                </div>



                                <div *ngIf="child.controls.ResponseValueTypeID.value === responseDocuSignType && child.controls.isHidden.value !== true"
                                  class="col-12" style="padding-left:0px">
                                  <div class="btmBtnLogoContainer align-start">
                                    <div
                                      *ngIf="child.controls.childValue.value == '-' || child.controls.childValue.value == null || child.controls.childValue.value == '';else buttonTemplate">
                                      <button type="button" class="btn btnBlueLight form-group ml-0 width-auto"
                                        (click)="generateLinkForChild(catIndex, verIndex, child.controls.ChildItemID.value, c)"
                                        mat-button>
                                        {{'Click here to DocuSign' | translate}}
                                      </button>
                                    </div>
                                    <ng-template #buttonTemplate>
                                      <button type="button"
                                        (click)="viewDocumentForChild(child.controls.childValue.value, catIndex, verIndex, c)"
                                        class="btn btnBlueLight form-group ml-0 width-auto" mat-button>
                                        {{'View Document' | translate}}
                                      </button>
                                    </ng-template>
                                  </div>
                                </div>

                                <div *ngIf="child.controls.ResponseValueTypeID.value === responseSliderType && child.controls.isHidden.value !== true"
                                  class="d-flex justify-content-evenly centerDiv">
                                  <div class="col-4">
                                    <label>{{child.controls.ChildItemTitle.value}}<span *ngIf="child.value.IsChildItemResponseRequired && isEnabledasterisk"  style="color: red;"> *</span></label>
                                  </div>
                                  <div class="col-8">
                                     <mat-slider
                                     [displayWith]="formatLabel"
                                     [min]="0"
                                     [max]="child.controls.MaxRangeValue?.value"
                                     step="1"
                                     discrete>
                                     <input
                                         matSliderThumb
                                         formControlName="childValue"
                                         (valueChange)="findAssesmentSummation()">

                                    </mat-slider>
                                    <label>
                                      {{child.controls.childValue.value}}<span *ngIf="child.value.IsChildItemResponseRequired && isEnabledasterisk"  style="color: red;"> *</span>
                                    </label>
                                  </div>
                                </div>

                                <div
                                  *ngIf="child.controls.ResponseValueTypeID.value === responseListType && child.controls.isHidden.value !== true && child.controls.IsChildItemResponseIdAvailable.value"
                                  class="d-flex justify-content-evenly centerDiv">
                                  <div class="col-4">
                                    <label>{{child.controls.ChildItemTitle.value}}<span *ngIf="child.value.IsChildItemResponseRequired && isEnabledasterisk"  style="color: red;"> *</span></label>
                                  </div>
                                  <div class="col-8">
                                    <mat-form-field
                                      [ngClass]="!child.controls?.childValue.valid && child.controls?.childValue.hasError('incorrect')? 'required':''"
                                      appearance="fill">
                                      <mat-select
                                        (selectionChange)="setDropDownValue($event, child.controls.Responses.value,catIndex,verIndex,c);findAssesmentSummation();"
                                        formControlName="ResponseId" (focus)="clearFilterValue(catIndex, verIndex, c)">
                                        <mat-option>
                                          <ngx-mat-select-search
                                            noEntriesFoundLabel="{{'No results found' | translate}}"
                                            hideClearSearchButton="true" placeholderLabel="{{'Search' | translate}}"
                                            [formControl]="titleFilterCtrl"
                                            (input)="filter(catIndex, verIndex, c)"></ngx-mat-select-search>
                                        </mat-option>
                                        <mat-option [value]="'-'">-</mat-option>
                                        <mat-option [formGroup]="childRes" [value]="childRes.controls.ResponseId.value" matTooltip="{{childRes.controls.Description.value}}"
                                        [matTooltipPosition]="'right'"
                                          *ngFor="let childRes of child.get('Responses').controls; let r=index">
                                          {{childRes.controls.Label.value | translate}}
                                          {{childRes.controls.Description.value | translate}}
                                        </mat-option>
                                      </mat-select>
                                    </mat-form-field>
                                  </div>
                                </div>

                                <div
                                  *ngIf="child.controls.ResponseValueTypeID.value === responseListType && child.controls.isHidden.value !== true && !child.controls.IsChildItemResponseIdAvailable.value"
                                  class="d-flex justify-content-evenly centerDiv">
                                  <div class="col-4">
                                    <label>{{child.controls.ChildItemTitle.value}}<span *ngIf="child.value.IsChildItemResponseRequired && isEnabledasterisk"  style="color: red;"> *</span></label>
                                  </div>
                                  <div class="col-8">
                                    <mat-form-field
                                      [ngClass]="!child.controls?.childValue.valid && child.controls?.childValue.hasError('incorrect')? 'required':''"
                                      appearance="fill">
                                      <mat-select
                                        (selectionChange)="setDropDownValue($event, child.controls.Responses.value,catIndex,verIndex,c);findAssesmentSummation();"
                                        formControlName="childValue">
                                        <mat-option [value]="'-'">-</mat-option>
                                        <mat-option [formGroup]="childRes" [value]="childRes.controls.Value.value" matTooltip="{{childRes.controls.Label.value}}"
                                        [matTooltipPosition]="'right'"
                                          *ngFor="let childRes of child.get('Responses').controls; let r=index">
                                          {{childRes.controls.Label.value}}
                                        </mat-option>
                                      </mat-select>
                                    </mat-form-field>
                                  </div>
                                </div>
                                <!----Address-->
                                <div
                                  *ngIf="child.controls.ResponseValueTypeID.value === responseCustomListType && child.controls.isHidden.value !== true"
                                  class="d-flex justify-content-evenly centerDiv">
                                  <div class="col-4">
                                    <label>{{child.controls.ChildItemTitle.value}}<span *ngIf="child.value.IsChildItemResponseRequired && isEnabledasterisk"  style="color: red;"> *</span></label>
                                  </div>
                                  <div class="col-8">
                                    <mat-form-field
                                      [ngClass]="!child.controls?.childValue.valid && child.controls?.childValue.hasError('incorrect')? 'required':''"
                                      appearance="fill">
                                      <mat-select #currentAddressDropdown
                                      (selectionChange)="setAddressDropDownValue($event, catIndex,verIndex,c);findAssesmentSummation();"
                                      formControlName="childValue"
                                      disableOptionCentering panelClass="assesmentValuesDropdown">
                                      <mat-option [value]="'-'"> - </mat-option>
                                      <mat-option *ngFor="let address of fullAddressList; let m = index" [value]="address.addressName" matTooltip="{{address.addressName}}"
                                      matTooltipPosition="right">
                                        {{address.addressName }}
                                      </mat-option>
                                    </mat-select>
                                    </mat-form-field>
                                  </div>
                                </div>
                                <div
                                  *ngIf="child.controls.ResponseValueTypeID.value === responseTextAreaType && child.controls.isHidden.value !== true"
                                  class="d-flex margin-bottom-30 centerDiv">
                                  <div class="col-4">
                                    <label>{{child.controls.ChildItemTitle.value}}<span *ngIf="child.value.IsChildItemResponseRequired && isEnabledasterisk"  style="color: red;"> *</span></label>
                                  </div>
                                  <div class="col-8">
                                    <mat-form-field
                                      class="text-area-height custom-hide-underline resizable-child-textarea-field">
                                      <textarea matInput formControlName="childValue" cdkTextareaAutosize (change)="findAssesmentSummation();"
                                        cdkAutosizeMinRows="1" cdkAutosizeMaxRows="5" [ngClass]="!child.controls?.childValue.valid && child.controls?.childValue.hasError('incorrect')? 'childTextAreaDrag required':'childTextAreaDrag'"
                                        [mask]="child?.controls?.ItemFormat?.value ? child?.controls?.ItemFormat?.value : null"
                                        ></textarea>
                                    </mat-form-field>
                                  </div>
                                </div>

                                <!-- <div *ngIf="9 === responseAttachmentType && child.controls.isHidden.value !== true"
                                  class="d-flex margin-bottom-30 centerDiv">
                                  <div class="col-4">
                                    <label>{{child.controls.ChildItemTitle.value}}<span *ngIf="child.value.IsChildItemResponseRequired && isEnabledasterisk"  style="color: red;"> *</span></label>
                                  </div>
                                  <div>
                                    <ng-container>
                                      <div class="file-input">
                                        <input type="file" [accept]="assessmentConfig" id="file" class="file"
                                          (change)="handleFileInput($event.target.files, catIndex,verIndex, child.value)">
                                        <label for="file">
                                          Browse
                                        </label>
                                      </div>
                                    </ng-container>
                                  </div>
                                  <div class="top-margin ">
                                    <div
                                      *ngFor="let files of getFiles( versionItem?.controls?.ItemId?.value, catIndex, verIndex).controls; let f = index"
                                      [formGroup]="files" class="d-flex" class="d-flex">
                                      <p (click)="downloadFile(files.value)" style="cursor: pointer"
                                        class="attachment-list file-name-list ">
                                        {{files.controls.fileName.value}}</p>
                                      <h5 class="stylednoteFont-attachment attachment-list">Created on
                                        {{ files?.controls?.UpdateDate?.value ? (files?.controls?.UpdateDate?.value
                                        |
                                        date:'MM/dd/yyyy') : (currentDate | date:'MM/dd/yyyy') }} by
                                        {{files?.controls?.Author?.value}}</h5>
                                      <i (click)="removeFile(catIndex, verIndex ,f, true)" style="cursor: pointer;"
                                        class="fa fa-trash delete-icon" aria-hidden="true"></i>
                                    </div>
                                  </div>
                                </div> -->

                                <div
                                  *ngIf="child.controls.ResponseValueTypeID.value === responseCheckboxType && child.controls.isHidden.value !== true"
                                  class="d-flex centerDiv styledHeight">
                                  <div class="col-1">
                                    <mat-checkbox (change)="findAssesmentSummation();" formControlName="childValue"
                                      [ngClass]="!child.controls?.childValue.valid && child.controls?.childValue.hasError('incorrect')? 'required':''"
                                      class="mr-3 styled-required-border"></mat-checkbox>
                                  </div>
                                  <div class="col-11">
                                    <label>{{child.controls.ChildItemTitle.value}}<span *ngIf="child.value.IsChildItemResponseRequired && isEnabledasterisk"  style="color: red;"> *</span></label>
                                  </div>
                                </div>
                                <div
                                  *ngIf="child.controls.ResponseValueTypeID.value === responseDateType && child.controls.isHidden.value !== true"
                                  class="d-flex justify-content-evenly centerDiv">
                                  <div class="col-4">
                                    <label>{{child.controls.ChildItemTitle.value}}<span *ngIf="child.value.IsChildItemResponseRequired && isEnabledasterisk"  style="color: red;"> *</span></label>
                                  </div>
                                  <div class="col-md-4 col-sm-6 col-8">
                                    <ng-container>
                                      <mat-form-field
                                        [ngClass]="!child.controls?.childValue.valid && child.controls?.childValue.hasError('incorrect')? 'required':''"
                                        appearance="fill">
                                        <mat-label>Date</mat-label>
                                        <input (dateChange)="findAssesmentSummation();" formControlName="childValue" matInput [matDatepicker]="picker"
                                          style="width:100px">
                                        <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                                        <mat-datepicker #picker></mat-datepicker>
                                      </mat-form-field>
                                    </ng-container>
                                  </div>
                                </div>
                                <a (click)="removeChildGroup(catIndex, verIndex,c, child.controls.total.value)"
                                  *ngIf="showRemoveGroup(c,child.controls.total.value) && versionItem.controls.displayMultiple.value "
                                  href="javascript:void(0)" class="AddItem"><i aria-hidden="true"
                                    class="fa fa-minus mr-1 mt-2 "></i>Remove {{versionItem.controls.Title.value}}
                                  Group</a>
                              </div>
                            </div>
                          </div>
                          <div *ngIf="isDisplayChild(versionItem.get('childItems').controls)" class="mt-3 styledColor">
                            <a *ngIf="versionItem.controls.displayChildItem.value && versionItem.controls.displayMultiple.value"
                              (click)="addChild(catIndex, verIndex)" href="javascript:void(0)"
                              class="AddItem styledLeft">
                              Add {{versionItem.controls.Title.value}} Group</a>
                          </div>

                          <!-- Mark as Confidential -->
                          <div class="details-row mt-3 radioStylesOverride"
                            *ngIf="versionItem.controls.resValue.value != null && requiredConfidentialityLanguage != null && versionItem.controls.UseRequiredConfidentiality.value">
                            <h2 class="subtitle">{{requiredConfidentialityLanguage}}:</h2>
                            <mat-radio-group
                              (change)="setConfidential($event, versionItem.controls, catIndex, verIndex, constants.requiredConfidentialityLanguage);"
                              [disabled]="isRequestSubmitted">
                              <mat-radio-button [value]="true"
                                [checked]="versionItem.controls.isRequiredConfidential.value">
                                {{'Yes'| translate}}
                              </mat-radio-button>
                              <mat-radio-button [value]="false"
                                [checked]="!versionItem.controls.isRequiredConfidential.value" class="ml-3">
                                {{'No' | translate}}
                              </mat-radio-button>
                            </mat-radio-group>
                          </div>

                          <div class="details-row mt-3 radioStylesOverride"
                            *ngIf="versionItem.controls.resValue.value != null && personRequestedConfidentialityLanguage != null && versionItem.controls.UsePersonRequestedConfidentiality.value">
                            <h2 class="subtitle">{{personRequestedConfidentialityLanguage}}:</h2>
                            <mat-radio-group
                              (change)="setConfidential($event, versionItem.controls, catIndex, verIndex, constants.personRequestedConfidentialityLanguage);"
                              [disabled]="isRequestSubmitted">
                              <mat-radio-button [value]="true"
                                [checked]="versionItem.controls.isPersonRequestedConfidential.value">
                                {{'Yes'| translate}}
                              </mat-radio-button>
                              <mat-radio-button [value]="false"
                                [checked]="!versionItem.controls.isPersonRequestedConfidential.value" class="ml-3">
                                {{'No' | translate}}
                              </mat-radio-button>
                            </mat-radio-group>
                          </div>

                          <div class="details-row mt-3 radioStylesOverride"
                            *ngIf="versionItem.controls.resValue.value != null && otherConfidentialityLanguage != null && versionItem.controls.UseOtherConfidentiality.value">
                            <h2 class="subtitle">{{otherConfidentialityLanguage}}:</h2>
                            <mat-radio-group
                              (change)="setConfidential($event, versionItem.controls, catIndex, verIndex, constants.otherConfidentialityLanguage);"
                              [disabled]="isRequestSubmitted">
                              <mat-radio-button [value]="true"
                                [checked]="versionItem.controls.isOtherConfidential.value">
                                {{'Yes'| translate}}
                              </mat-radio-button>
                              <mat-radio-button [value]="false"
                                [checked]="!versionItem.controls.isOtherConfidential.value" class="ml-3">
                                {{'No' | translate}}
                              </mat-radio-button>
                            </mat-radio-group>
                          </div>

                          <div
                            *ngIf="versionItem.controls.considerations.value != null && versionItem.controls.considerations.value != ''"
                            class="details-row">
                            <h2 class="subtitle">{{'Considerations'| translate}}:</h2>
                            <p class="versiontitle" style="text-align: justify;">
                              {{versionItem.controls.considerations.value}}
                            </p>
                          </div>
                          <div
                            *ngIf="versionItem.controls.supplementalDescription.value != null && versionItem.controls.supplementalDescription.value != ''"
                            class="details-row">
                            <h2 class="subtitle">{{'Supplemental Description' | translate}}:</h2>
                            <p class="versiontitle contentText"
                              [innerHtml]="versionItem.controls.supplementalDescription.value"></p>
                          </div>
                          <!-- Notes -->
                          <ng-container
                            *ngIf="showHideNotes(versionItem.controls.NotesRequired.value, versionItem.controls.ShowNotes.value)">
                            <div class="details-row mt-3" *ngIf="versionItem.controls.resValue.value != null">
                              <h2 *ngIf="getNotesLength(versionItem.controls) != 0" class="subtitle">{{'Notes or Comments' | translate}}:
                              </h2>
                              <div *ngFor="
                                let note of getNotes(versionItem.controls)
                                  .controls;
                                let noteIndex = index
                              " [formGroup]="note">
                                <hr />
                                <ng-container *ngIf="!note.controls.isEdit.value">
                                  {{ note.controls.noteText.value }}
                                </ng-container>

                                <ng-container *ngIf="note.controls.isEdit.value">
                                  <div class="col-12 d-flex">
                                    <div class="col-10">
                                      <mat-form-field [formGroup]="versionItem" hideRequiredMarker class="custom-hide-underline">
                                        <mat-label>{{'Notes or Comments' | translate}}<span style="color: red">*</span>
                                        </mat-label>
                                        <textarea matInput formControlName="noteText" class="noteTextAreaDrag"
                                          [attr.maxLength]="constants?.descriptionLength" #noteEditInput></textarea>
                                      </mat-form-field>
                                    </div>
                                    <div class="col-1 style-center">
                                      <a href="javascript:void(0)" class="checkItem" (click)="
                                        setNotes(
                                          versionItem.controls,
                                          'edit',
                                          noteIndex
                                        )
                                      ">
                                        <i class="fa fa-check-circle"></i>
                                      </a>
                                    </div>
                                    <div class="col-1 style-center">
                                      <a href="javascript:void(0)" class="deleteItem" (click)="
                                        clearNotes(
                                          versionItem.controls,
                                          noteIndex
                                        )
                                      ">
                                        <i class="fa fa-times-circle"></i>
                                      </a>
                                    </div>
                                  </div>
                                </ng-container>
                                <div class="d-flex justify-content-end styledMargin" *ngIf="!isRequestSubmitted">
                                  <div>
                                    <div class="mb-2">
                                      <a href="javascript:void(0)" class="AddItem assesmentAddBtn" (click)="
                                        editNote(
                                          versionItem.controls,
                                          noteIndex
                                        )
                                      ">
                                        <i aria-hidden="true" class="fa fa-plus mr-1"></i>{{'Edit Note' | translate}}
                                      </a>
                                    </div>
                                    <div class="mb-2">
                                      <a href="javascript:void(0)" class="AddItem assesmentAddBtn"
                                      (click)="deleteItemPopUp(versionItem.controls,noteIndex)">
                                        <i aria-hidden="true" class="fa fa-minus mr-1"></i>{{'Delete Note' | translate}}
                                      </a>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div *ngIf="versionItem.controls.showAddNote.value">
                                <hr />
                                <div class="col-12 styledNoteContainer">
                                  <div class="col-lg-7">
                                    <mat-form-field [formGroup]="versionItem" hideRequiredMarker class="custom-hide-underline">
                                      <mat-label>{{'Notes or Comments' | translate}} <span style="color: red">*</span></mat-label>
                                      <textarea matInput formControlName="noteText" class="noteTextAreaDrag"
                                        [attr.maxLength]="constants?.descriptionLength" #noteInput></textarea>
                                    </mat-form-field>
                                  </div>
                                  <div class="ml-5 mb-5 style-center d-flex buttonContainer">
                                    <a href="javascript:void(0)" class="checkItem"
                                      (click)="setNotes(versionItem.controls)">
                                      <i class="fa fa-check-circle"></i>
                                    </a>

                                    <a href="javascript:void(0)" class="deleteItem"
                                      (click)="clearNotes(versionItem.controls)">
                                      <i class="fa fa-times-circle"></i>
                                    </a>
                                  </div>
                                </div>
                                <hr />
                              </div>
                              <div *ngIf="!versionItem.controls.showAddNote.value">
                                <hr />
                              </div>
                              <div class="d-flex justify-content-end" *ngIf="
                                versionItem.controls.showAddNoteLink.value &&
                                !isRequestSubmitted
                              ">
                                <a href="javascript:void(0)" class="AddItem assesmentAddBtn"
                                  (click)="addNote(versionItem.controls)">
                                  <i aria-hidden="true" class="fa fa-plus mr-1"></i>{{'Add Note' | translate}}
                                </a>
                              </div>
                            </div>
                          </ng-container>
                        </div>
                      </div>
                    </div>
                  </div>
                </ng-container>
                <!-- <div class="careGiverBtns" *ngIf="category.controls.showSupportDropDown.value">
                  <div class="singleTdBorderStyles" *ngIf="!isRequestSubmitted" colspan="9">
                    <div class="">
                      <div class="d-flex justify-content-end" *ngIf="
                          checkSupports(category.controls) &&
                          category.controls.supportID.value != null
                        ">
                        <a class="styled-email-link" href="javascript:void(0)"
                          (click)="addSuporter(category.controls, catIndex)"><i aria-hidden="true"
                            class="fa fa-plus mr-1"></i>ADD
                          SUPPORT</a>
                      </div>
                      <div class="d-flex justify-content-end mt-1">
                        <a class="styled-email-link" href="javascript:void(0)" (click)="removeSupporter(catIndex)"><i
                            aria-hidden="true" class="fa fa-minus mr-1"></i>REMOVE SUPPORT</a>
                      </div>
                    </div>
                  </div>
                </div> -->
              </div>
            </div>
          </ng-container>
          <div class="padding-top-25 btmBtnLogoContainer">
            <div class="btmLogoContainer">
              <div *ngIf="questionsAndDetails.instrumentUrl !=''">
                <div *ngIf="!questionsAndDetails.instrumentUrl?.includes('/Logo.png')">
                  <img class="logoCansStyles" src="{{questionsAndDetails.instrumentUrl}}" />
                </div>
                <div *ngIf="questionsAndDetails.instrumentUrl?.includes('/Logo.png')">
                  <img class="logoOtherStyles" src="{{questionsAndDetails.instrumentUrl}}" />
                </div>
              </div>
              <div
                *ngIf="(questionsAndDetails.instrumentUrl =='' || questionsAndDetails.instrumentUrl == null) && !isMagellan ">
                <img class="logoOtherStyles" src="../../../../assets/icons/P-CIS.png" />
              </div>
              <div
                *ngIf="(questionsAndDetails.instrumentUrl =='' || questionsAndDetails.instrumentUrl == null) && isMagellan">
                <img class="logoOtherStyles" src="../../../../assets/icons/Magellan-Logo.png" />
              </div>
            </div>
          </div>
          <div class="reviewerItemsContainer mx-auto">
            <div class="col-12 nopad d-flex justify-content-center">
              <div class="approveRejectBtnContainer">
                <div *ngIf="!isRequestSubmitted" class="col-12">
                  <button class="btn btnApprove" (click)="saveConfirmation()">
                    {{'Submit' |translate}}
                  </button>
                  <button class="btn btnReject" (click)="resetAssessment()">
                    {{'Cancel' | translate}}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </form>
    </div>
  </div>
</div>

<!-- OTP verification form -->
<div *ngIf="!isAuth && !isRequestInvalid && otpVerification" style="display: flex">
  <div class="widthSidebar">
    <!-- sidebar -->
    <div class="menu-trigger" id="hamburgerBtn" (click)="hamburgerOpen()">
      <span></span>
      <span></span>
      <span></span>
    </div>
    <div id="overlay" class="hideOverlay" (click)="closeSidebar()"></div>

    <div class="sidenavmain hideDiv" id="sidebar">
      <div class="sidenav">
        <div class="menu-close" (click)="closeSidebar()"
          [style.color]="brandingDetails?.branding?.BackgroundColors?.CloseIcon">
          <i class="fa fa-times"></i>
        </div>
        <div class="logo d-flex justify-content-center">
          <a [routerLink]="['/dashboard']">
            <img class="logoIcon" src="{{brandingDetails?.branding?.MainLogo}}" />
          </a>
        </div>
      </div>
    </div>
  </div>

  <div class="widthHeader">
    <!-- header -->
    <div class="Header col-12 nopad">
      <div class="row noMargin justify-content-between headerSpace">
        <!-- <div class="headerTextContainer">
          <h2 class="long styledName">Person Centered Intelligence Solution</h2>
          <h2 class="short styledName">PCIS</h2>
        </div> -->
      </div>
    </div>

    <!-- otp section -->
    <div class="mainDiv">
      <div class="col-md-12">
        <div class="styled-otp-container">
          <div class="styled-otp-header pb-4"  *ngIf="inviteToCompleteHtmlContent; else noInviteToCompleteHtmlContenttemplate">
           <div [innerHTML]="inviteToCompleteHtmlContent"></div>
          </div>
           <ng-template #noInviteToCompleteHtmlContenttemplate>
           <div class="styled-otp-header pb-4" >
            <h3>Thank You!</h3>
          </div>
           </ng-template>
          <div class="styled-otp-title pb-4">
            <p>
              {{otpText}}
            </p>
          </div>
          <div>
            <div class="styled-otp-form">
              <div class="title-container">
                <div class="title">Verification Code:</div>
              </div>
              <form [formGroup]="otpVerification">
                <div class="d-flex group-input-btn">
                  <div>
                    <input type="text" formControlName="code" class="form-control otp-input" maxlength="15" />
                    <mat-error *ngIf="
                        code.invalid && code.errors.required && code.touched
                      ">
                      {{ alertMessage.otpReq }}</mat-error>
                  </div>
                  <div class="d-flex">
                    <button type="button" (click)="startAssessment()" class="btn btnotp ml-2">
                      Start
                    </button>
                    <button type="button" class="btn btnResend ml-2" (click)="resendOtp()" [disabled]="resetBtnDisable">
                      Resend
                    </button>
                  </div>

                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!--Email Submit Message-->

<div *ngIf="isRequestInvalid" style="display: flex">
  <div class="widthSidebar">
    <!-- sidebar -->
    <div class="menu-trigger" id="hamburgerBtn" (click)="hamburgerOpen()">
      <span></span>
      <span></span>
      <span></span>
    </div>
    <div id="overlay" class="hideOverlay" (click)="closeSidebar()"></div>

    <div class="sidenavmain hideDiv" id="sidebar">
      <div class="sidenav">
        <div class="menu-close" (click)="closeSidebar()"
          [style.color]="brandingDetails?.branding?.BackgroundColors?.CloseIcon">
          <i class="fa fa-times"></i>
        </div>
        <div class="logo d-flex justify-content-center">
          <a [routerLink]="['/dashboard']">
            <img class="logoIcon" src="{{brandingDetails?.branding?.MainLogo}}" />
          </a>
        </div>
      </div>
    </div>
  </div>

  <div class="widthHeader">
    <!-- header -->
    <div class="Header col-12 nopad">
      <div class="row noMargin justify-content-between headerSpace">
        <!-- <div class="headerTextContainer">
          <h2 class="long styledName">Person Centered Intelligence Solution</h2>
          <h2 class="short styledName">PCIS</h2>
        </div> -->
      </div>
    </div>

    <!-- otp section -->
    <div class="mainDiv">
      <div class="col-md-12">
        <div class="styled-otp-container">
          <div class="styled-otp-title pb-4">
            <h3>
              {{ errorMessage }}
            </h3>
          </div>
          <div class="d-flex" *ngIf="invalidStatusCode === 1027">
            <button type="button" (click)="resendLink()" class="btn btnResend" [disabled]="!enableResendLink">
              Resend Link
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<ng-template #template>
  <div class="modal-header">
    <h4 class="modal-title">
      Confirm
    </h4>
    <button type="button" class="close" aria-label="Close" (click)="modalRef.hide()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <div>{{message}}</div>
    <div class="d-flex justify-content-center">
      <button type="button" class="btn btn-sm btnDelete mr-2" (click)="commonModalEvent()">
        {{btnText}}
      </button>
      <button type="button" class="btn btn-sm btnCancel" (click)="modalRef.hide()">
        Cancel
      </button>
    </div>
  </div>
</ng-template>

<!-- delete conform popup -->
<app-confirmation-dialog [Message]="conformMessage" (modalEvent)="getModalEvent($event)"></app-confirmation-dialog>

<!-- save conform popup -->
<app-confirm-save [Message]="saveConformMessage" (modalEvent)="getModalEvent($event)" [btnLabel]="'Submit'">
</app-confirm-save>
<app-confirmation-success-email [header]="header" [Msg]="Msg"></app-confirmation-success-email>
<app-confirm-discard (modalEvent)="getModalEventDiscard($event)" [Message]="confirmChildValueDiscardMessage" [ModalTriggerFrom]="modalTriggerFrom" [btnLabel]="confirmBtnLabel" [cancelBtnLabel]="confirmCancelBtnLabel"></app-confirm-discard>
